<template>
  <v-container fluid class="pa-0 ma-0">
    <div class="flex w-full">
      <div class="w-full sm:w-1/2 xs:w-2/3" v-if="!isMobile || centerV" key="centerV">
        <v-row no-gutters>
          <v-dialog v-model="dialog" dark persistent max-width="400">
            <v-card class="!bg-black pb-2 !border-0 !rounded-tr-2xl !rounded-bl-2xl">
              <v-btn icon right class="!right-0 !absolute" @click="dialog = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
              <v-card-title
                class="text-xl !break-normal text-center !block !font-Handel"
                :class="`${routeLink}_text_color`"
              >
                Please select your
                <v-tooltip top dark color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="font-weight-bold" v-bind="attrs" v-on="on"> date </span>
                  </template>
                  <span :class="`${routeLink}_text_color`"
                    >The term(Dutch) stems from restaurant dining etiquette in the Western
                    world, where each person pays for their meal.</span
                  >
                </v-tooltip>
                type
              </v-card-title>
              <v-row justify="space-around" align="center" no-gutters>
                <v-btn
                  class="white--text font-Handel"
                  :loading="standardLoad"
                  small
                  text
                  @click="sendRequest('Standard')"
                >
                  Standard
                </v-btn>
                <v-btn
                  class="font-Handel white--text"
                  small
                  text
                  @click="sendRequest('Dutch')"
                >
                  Dutch
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
          <v-col cols="12" :class="`${routeLink}_centerGradient `" class="relative z-10">
            <div class="flex justify-center">
              <v-avatar tile height="100" width="150" class="mt-4">
                <img class="" :src="require('@/assets/img/Logo/logo.gif')" />
              </v-avatar>
            </div>
            <v-col class="overflow-y-auto h-[calc(100vh-110px)]">
              <v-row class="flex-col">
                <v-col class="py-0 px-2">
                  <div class="justify-center d-flex h-[calc(100vh-210px)]">
                    <AdPreview v-if="shouldShowAd" v-motion-pop />
                    <NoMoreProfile v-else-if="noProfile" />
                    <PreviewCard
                      v-else
                      :name="previewProfile.name"
                      :subtitle="previewProfile.location"
                      :key="previewProfile.name"
                      :video="previewProfile.video"
                      :img="previewProfile.image"
                      :loading="loadingProfile"
                      :description="previewProfile.about"
                      :age="previewProfile.age"
                      v-motion
                      :initial="{ opacity: 0, x: 100 }"
                      :enter="{
                        opacity: 1,
                        x: 0,
                        transition: {
                          duration: 400,
                          type: 'keyframes',
                          ease: 'easeIn',
                        },
                      }"
                    />
                  </div>
                </v-col>
                <v-col
                  class="h-[80px] my-1 drop-shadow-[10px_5px_6px_rgba(0,0,0,0.6)] d-flex justify-center gap-10 items-center"
                  v-motion
                  :initial="{ opacity: 0, y: 100 }"
                  :enter="{
                    opacity: 1,
                    y: 0,
                    transition: {
                      duration: 400,
                      type: 'keyframes',
                      ease: 'easeInOut',
                      delay: 100,
                    },
                  }"
                >
                  <v-tooltip top dark color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        fab
                        dark
                        @click="removeProfile"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-img
                          max-width="80%"
                          :src="require(`@/assets/img/icons/${routeLink}/reject.png`)"
                          alt
                        />
                      </v-btn>
                    </template>
                    <span :class="`${routeLink}_text_color`">Skip to next</span>
                  </v-tooltip>
                  <!-- <v-tooltip top dark color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon fab dark @click="nextProfile" v-bind="attrs" v-on="on">
                        <v-img
                          max-width="80%"
                          :src="require(`@/assets/img/icons/${routeLink}/date.png`)"
                          alt
                        />
                      </v-btn>
                    </template>
                    <span :class="`${routeLink}_text_color`">Send date request</span>
                  </v-tooltip> -->
                  <NavButton
                    iconSize="text-5xl"
                    iconName="tabler:heart-handshake"
                    name="Send Serious Date Request"
                    @callFunction="fn_handle(sendRequest('Serious Relationship'))"
                  />

                  <v-tooltip top dark color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon fab dark @click="nextProfile" v-bind="attrs" v-on="on">
                        <v-img
                          max-width="80%"
                          :src="require(`@/assets/img/icons/${routeLink}/date.png`)"
                          alt
                        />
                      </v-btn>
                    </template>
                    <span :class="`${routeLink}_text_color`">Send date request</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row class="px-4 py-2" v-if="previewProfile">
                <v-col cols="12">
                  <h3
                    class="text-2xl font-semibold font-Nunito capitalize"
                    v-motion
                    :initial="{
                      y: 100,
                      opacity: 0,
                    }"
                    :visible="{
                      y: 0,
                      opacity: 1,
                      transition: {
                        duration: 300,
                        type: 'keyframes',
                        ease: 'easeIn',
                      },
                    }"
                  >
                    <span :class="`${routeLink}_text_color`">BIO</span>
                    {{ previewProfile.name }}
                  </h3>
                </v-col>
                <v-divider />
                <v-col cols="12">
                  <v-list dense color="transparent" class="">
                    <v-list-item
                      class="text-white pa-0"
                      v-motion
                      :initial="{
                        y: 100,
                        opacity: 0,
                      }"
                      :visible="{
                        y: 0,
                        opacity: 1,
                        transition: {
                          duration: 300,
                          type: 'keyframes',
                          ease: 'easeIn',
                        },
                      }"
                    >
                      <v-list-item-icon>
                        <Icon
                          icon="ri:shield-user-line"
                          :color="colorAsRoute"
                          width="25"
                        />
                        <!-- <v-icon :color="colorAsRoute">mdi-book-education</v-icon> -->
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="!text-lg font-Handel !capitalize"
                          >{{
                            previewProfile.account_type == 3
                              ? "Straight"
                              : previewProfile.account_type == 2
                              ? "Gay"
                              : "Lesbian"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      class="text-white pa-0"
                      v-motion
                      :initial="{
                        y: 100,
                        opacity: 0,
                      }"
                      :visible="{
                        y: 0,
                        opacity: 1,
                        transition: {
                          duration: 300,
                          type: 'keyframes',
                          ease: 'easeIn',
                        },
                      }"
                    >
                      <v-list-item-icon>
                        <v-icon :color="colorAsRoute">mdi-book-education</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="!text-lg font-Handel !capitalize"
                          >{{
                            previewProfile.education
                              ? previewProfile.education
                              : "Education Not Available"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      class="text-white pa-0"
                      v-motion
                      :initial="{
                        y: 100,
                        opacity: 0,
                      }"
                      :visible="{
                        y: 0,
                        opacity: 1,
                        transition: {
                          duration: 300,
                          type: 'keyframes',
                          ease: 'easeIn',
                        },
                      }"
                    >
                      <v-list-item-icon>
                        <v-icon :color="colorAsRoute">mdi-map-marker-multiple</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="!text-lg font-Handel !capitalize"
                          >{{
                            previewProfile.partner_age_range
                              ? previewProfile.partner_age_range
                              : "Partner Age Range Not Available"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      class="text-white pa-0"
                      v-motion
                      :initial="{
                        y: 100,
                        opacity: 0,
                      }"
                      :visible="{
                        y: 0,
                        opacity: 1,
                        transition: {
                          duration: 300,
                          type: 'keyframes',
                          ease: 'easeIn',
                        },
                      }"
                    >
                      <v-list-item-icon>
                        <v-icon :color="colorAsRoute">mdi-briefcase</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="!text-lg font-Handel !capitalize">{{
                          previewProfile.job
                            ? previewProfile.job
                            : "Job Status Not Available"
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider />
                <v-col cols="12">
                  <h3
                    class="text-xl font-Handel my-2"
                    v-motion
                    :initial="{
                      y: 100,
                      opacity: 0,
                    }"
                    :visible="{
                      y: 0,
                      opacity: 1,
                      transition: {
                        duration: 300,
                        type: 'keyframes',
                        ease: 'easeIn',
                      },
                    }"
                  >
                    <span class="text-slate-300">Hobbies :</span>
                  </h3>
                  <div class="hobbies">
                    <v-list-item-title
                      v-if="
                        previewProfile.user_intrests &&
                        !previewProfile.user_intrests.length > 0
                      "
                      class="!text-lg font-Handel !capitalize bg-black !text-center rounded-lg py-3"
                      v-motion
                      :initial="{
                        x: 100,
                        opacity: 0,
                      }"
                      :visible="{
                        x: 0,
                        opacity: 1,
                        transition: {
                          duration: 300,
                          type: 'keyframes',
                          ease: 'easeIn',
                        },
                      }"
                    >
                      Hobbies Not Available
                    </v-list-item-title>
                    <v-chip
                      v-else
                      :class="`ma-2 hover:scale-110 !duration-500 font-Handel !transition-transform text-black ${routeLink}_color`"
                      :color="
                        `${routeLink}` == 'straight'
                          ? '#cba440'
                          : `${routeLink}` == 'gay'
                          ? '#78a8f4'
                          : `${routeLink}` == 'lesbian'
                          ? '#a032f5'
                          : ''
                      "
                      v-for="(item, i) in previewProfile.user_intrests"
                      :key="item.key"
                      v-motion
                      :initial="{
                        y: 100,
                        opacity: 0,
                      }"
                      :visible="{
                        y: 0,
                        opacity: 1,
                        transition: {
                          duration: 300,
                          type: 'keyframes',
                          ease: 'easeInOut',
                          delay: `${i}00`,
                        },
                      }"
                    >
                      {{ item.interest.title }}
                    </v-chip>
                  </div>
                </v-col>
                <v-divider />
                <v-col
                  cols="12"
                  v-motion
                  :initial="{
                    y: 100,
                    opacity: 0,
                  }"
                  :visible="{
                    y: 0,
                    opacity: 1,
                    transition: {
                      duration: 300,
                      type: 'keyframes',
                      ease: 'easeIn',
                    },
                  }"
                >
                  <h3 class="text-xl font-Handel my-2">
                    <span class="text-slate-300">About :</span>
                  </h3>
                  <p
                    class="text-sm !font-Handel break-words"
                    :class="
                      !previewProfile.about
                        ? 'bg-black !text-center rounded-lg py-3 !text-lg'
                        : ''
                    "
                  >
                    {{
                      previewProfile.about ? previewProfile.about : "About Not Available"
                    }}
                  </p>
                </v-col>
              </v-row>
              <v-row
                class="h-[calc(50vh)] mb-5 !grid place-items-center font-Handel text-xl bg-black !text-center rounded-lg py-3 mx-4"
                v-if="checkImages"
                v-motion
                :initial="{
                  y: 100,
                  opacity: 0,
                }"
                :visible="{
                  y: 0,
                  opacity: 1,
                  transition: {
                    duration: 300,
                    type: 'keyframes',
                    ease: 'easeIn',
                  },
                }"
              >
                Images Not Available
              </v-row>
              <v-row class="pt-2" no-gutters>
                <v-col
                  v-for="(item, idx) in previewProfile.user_images"
                  :key="item.img"
                  cols="6"
                  class="pa-1 relative !cursor-pointer"
                  v-motion-pop-visible
                >
                  <div
                    class="absolute top-0 left-0 z-20 w-full h-[80%]"
                    @click="showMultiple(idx)"
                  ></div>
                  <v-img
                    :src="item.image"
                    :lazy-src="item.img"
                    aspect-ratio="1"
                    gradient="to top, rgba(0,0,0,1), rgba(0,0,0,0)"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                    <template v-slot:default>
                      <div class="grid w-full h-full grid-flow-col align-items-end">
                        <v-btn
                          text
                          dark
                          :color="checkLiked(item) ? colorAsRoute : ''"
                          @click.prevent="likeSetter(item)"
                        >
                          <v-icon :color="checkLiked(item) > 0 ? colorAsRoute : ''" small
                            >mdi-thumb-up</v-icon
                          >
                          <span v-if="item.likes_count > 0" class="ml-2">
                            {{ item.likes_count }}</span
                          >
                        </v-btn>
                        <v-btn
                          text
                          dark
                          :color="checkLoved(item) ? colorAsRoute : ''"
                          @click.prevent="loveSetter(item)"
                        >
                          <v-icon :color="checkLoved(item) ? colorAsRoute : ''" small
                            >mdi-heart</v-icon
                          >
                          <span v-if="item.loves_count > 0" class="ml-2">
                            {{ item.loves_count }}</span
                          >
                        </v-btn>
                      </div>
                    </template>
                  </v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </div>
      <div
        class="hidden w-1/3 sm:w-1/2 xs:block relative h-screen"
        v-if="!isMobile || rightV"
        key="rightV"
      >
        <TransitionGroup
          tag="div"
          name="fade"
          mode="out-in"
          duration="1000"
          type="transition"
        >
          <ProfileCard
            :loading="loadingProfile"
            v-for="(profile, i) in profiles"
            :name="profile.name"
            :subtitle="profile.location"
            :description="profile.about"
            :age="profile.age"
            :img="profile.image"
            :key="i"
            :index="i"
          />
        </TransitionGroup>
      </div>
      <VueEasyLightbox
        moveDisabled
        :visible="visible"
        :imgs="images"
        :index="index"
        @hide="handleHide"
      >
      </VueEasyLightbox>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import VueEasyLightbox from "vue-easy-lightbox";
import { Icon } from "@iconify/vue2";
import AdPreview from "./AdPreview.vue";
import NoMoreProfile from "./NoMoreProfile.vue";
import NavButton from "@/components/NavButton.vue";

export default {
  data() {
    return {
      hobbies: "",
      age_from: "",
      age_to: "",
      reqUrl: "",
      loadingProfile: false,
      images: [], // Img Url , string or Array
      visible: false,
      index: 0, // default
      profiles: [{}, {}, {}],
      dummyProfiles: [],
      countProfileFetchPage: 8,
      dialog: false,
      filters: this.$store.getters.getSearchFilters,
      standardLoad: false,
      previewProfile: {
        name: "",
        subtitle: "",
        description: "",
        img: "",
      },
      profileData: [
        {
          name: "",
          subtitle: "",
          description: "",
          img: "",
        },
      ],
      filters: [],
      storeSubscription: null,
      usersAdded: 0,
      noProfile: false,
    };
  },
  computed: {
    shouldShowAd() {
      return this.usersAdded % 2 === 0 && this.usersAdded > 0;
    },
    checkImages() {
      if (this.previewProfile.user_images && this.previewProfile.user_images.length > 0) {
        return false;
      } else {
        return true;
      }
    },

    colorAsRoute() {
      if (this.routeLink == "straight") {
        return "#a07a1d";
      } else if (this.routeLink == "gay") {
        return "#88c3fa";
      } else if (this.routeLink == "lesbian") {
        return "#9e2eec";
      }
    },
  },
  watch: {
    filters: {
      handler() {
        let ageRangeFilter = {};
        if (this.filters?.age_from.length) {
          ageRangeFilter = {
            ...this.filters,
            age_from: this.filters.partner_age_range[0],
            age_to: this.filters.partner_age_range[1],
          };
        } else {
          ageRangeFilter = this.filters;
        }
        this.reqUrl = ageRangeFilter;
        this.fetchandPreview();

        // this.$router.replace({ name: this.$route.name, query: ageRangeFilter });
      },
      deep: true,
    },

    dummyProfiles: {
      async handler(oldVal, newVal) {
        if (newVal.length < 3 && newVal.length !== 0 && newVal !== undefined) {
          const prof = await this.fetchProfiles(1, this.countProfileFetchPage);
          // console.log(prof, "Fetch new profiles");
          if (prof.length > 0) {
            this.dummyProfiles.unshift(...prof);
          }
          // this.profiles.unshift(...prof);
          this.countProfileFetchPage += 1;
        }
      },
      deep: true,
    },
  },
  methods: {
    fn_handle(fn_name) {
      if (fn_name) {
        console.log(fn_name, "fn_name");
        return fn_name;
      }
    },
    checkLiked(item) {
      if (item.liked_by) {
        return true;
      } else {
        const userId = this.$store.getters.StateUser.data.id;
        return item.likes.find((e) => e.liked_by == userId);
      }
    },
    checkLoved(item) {
      if (item.loved_by) {
        return true;
      } else {
        const userId = this.$store.getters.StateUser.data.id;
        return item.loves.find((e) => e.loved_by == userId);
      }
    },
    async likeSetter(image) {
      try {
        const resp = await axios.post("users/like/image", {
          image_id: image.id,
          user_id: this.previewProfile.id,
        });
        console.log(resp);
        if (resp.status == 200) {
          image.likes_count = resp.data.data.likes_count;
          image.liked_by = this.$store.getters.StateUser.data.id;
        }
      } catch (error) {
        console.log(error.response.data.message);
        await this.$store.dispatch("errorAction", error.response.data.message, {
          root: true,
        });
      }
    },
    async loveSetter(image) {
      try {
        const resp = await axios.post("users/love/image", {
          image_id: image.id,
          user_id: this.previewProfile.id,
        });
        console.log(resp);
        if (resp.status == 200) {
          image.loves_count = resp.data.data.loves_count;
          image.loved_by = this.$store.getters.StateUser.data.id;
        }
      } catch (error) {
        console.log(error.response.data.message);
        await this.$store.dispatch("errorAction", error.response.data.message, {
          root: true,
        });
      }
    },
    nextProfile() {
      // const idx = (this.profiles.length - 1).toString();
      // const elem = document.querySelector(`div[index='${idx}']`);
      // elem.classList.add("animate__animated");
      // elem.classList.add("animate__fadeOutLeft");
      this.dialog = true;
    },
    async sendRequest(type) {
      try {
        this.dialog = false;
        // this.standardLoad = true;
        const resp = await axios.post(
          `send-user-request?to_uuid=${this.previewProfile.uuid}`
        );
        //  console.log(resp.data.data)
        this.$toast(
          `${type} Date request sent to ${this.previewProfile.name}. We'll let you know as soon as they respond. Good luck!`,
          {
            position: "top-left",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: {
              iconClass: "mdi mdi-checkbox-multiple-marked-outline",
              iconChildren: "",
              iconTag: "i",
            },
            rtl: false,
          }
        );
        this.notifyUser(type);
      } catch (error) {
        console.log(error);
      } finally {
        this.removeProfile();
        // this.standardLoad = false;
      }
    },
    removeProfile() {
      if (!this.noProfile) {
        this.usersAdded++;
      }
      if (this.usersAdded % 2 !== 0 || this.usersAdded == 0) {
        const sendProfileForPreview = this.profiles.pop();
        if (sendProfileForPreview) {
          this.previewProfile = sendProfileForPreview;
        } else {
          this.noProfile = true;
        }
        const profileSing = this.dummyProfiles.pop();
        if (profileSing) {
          this.profiles.unshift(profileSing);
        }
      }
      // this.previewProfile = this.profiles[this.profiles.length - 1];
      // this.profiles.pop();
    },
    async notifyUser(type) {
      const receiver_name = this.previewProfile.name;
      let messageData;
      if (type == "Dutch") {
        messageData = `{"subject":"Invitation for a ${type} Date","message":" let's make it a ${type} date and split the bill! Want to grab a drink? Let's Connect! if you want to connect with ${this.$store.getters.StateUser.data.name}?", "user_data":"${this.$store.getters.getCometUUID}" ,"user_id":"${this.$store.getters.StateUser.data.id}", "sender_name":"${this.$store.getters.StateUser.data.name}", "user_image":"${this.$store.getters.StateUser.data.image}", "for_toast":"You have received a date request from ${this.$store.getters.StateUser.data.name}. Check your notifications to accept or decline the invitation."  }`;
      } else {
        messageData = `{"subject":"Invitation for a ${type} Date","message":" I'd love to take you out on a proper date. How about we meet for meetup ?", "user_data":"${this.$store.getters.getCometUUID}" , "user_id":"${this.$store.getters.StateUser.data.id}", "for_toast":"You have received a date request from ${this.$store.getters.StateUser.data.name}. Check your notifications to accept or decline the invitation." ,"sender_name":"${this.$store.getters.StateUser.data.name}", "user_image":"${this.$store.getters.StateUser.data.image}" }`;
      }
      const resp = await axios.post("store-notification", {
        uuid: this.$store.getters.getCometUUID,
        notifiable_id: this.previewProfile.id,
        data: messageData,
      });

      console.log(resp);
    },
    showMultiple(idx) {
      this.images = this.previewProfile.user_images.map((item) => item.image);
      this.index = idx; // index of imgList
      this.show();
    },
    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    async fetchProfiles(limit = 7, page = 1) {
      let account_type = "";
      if (!this.filters.interestType) {
        account_type = this.$store.getters.StateUser.data.account_type;
      } else {
        account_type = this.filters.interestType;
      }
      if (this.reqUrl.hobbies) {
        this.hobbies = this.reqUrl.hobbies;
        this.age_from = this.reqUrl.age_from;
        this.age_to = this.reqUrl.age_to;
      } else {
        this.hobbies = "";
        this.age_from = "";
        this.age_to = "";
      }
      try {
        // this.$store.dispatch('setloading' , true)
        const resp = await axios.get(
          `/all-profiles?search=${this.hobbies}&limit=${limit}&page=${page}&account_type=${account_type}&age_from=${this.age_from}&age_to=${this.age_to}`
        );
        return resp.data.data.data;
      } catch (error) {
        console.error(error);
        return [];
      } finally {
        // this.$store.dispatch('setloading' , false)
        // this.loadingProfile = false;
      }
    },
    async fetchandPreview() {
      try {
        this.loadingProfile = true;
        const prof = await this.fetchProfiles();
        this.previewProfile = prof[0];
        this.dummyProfiles = prof.splice(1, 6);
        this.profiles = this.dummyProfiles.splice(0, 3);
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingProfile = false;
      }
    },
  },
  async created() {
    this.storeSubscription = this.$store.subscribe((mutation, state) => {
      if (mutation.type == "setSearchFilters") {
        this.filters = mutation.payload;
      }
      if (mutation.type == "viewSetter") {
        if (mutation.payload.right === "block") {
          console.log(mutation.payload, "mutation from profile");
          this.$store.dispatch("setView", {
            left: "none",
            center: "block",
            right: "none",
          });
        }
        ``;
      }
    });
    // const prof = await this.fetchProfiles();
    // this.profiles = prof.splice(1, 3);
    // this.previewProfile = prof[0];
    // console.log(this.previewProfile)
  },
  beforeDestroy() {
    this.storeSubscription();
  },
  mounted() {
    if (this.filters.age_from) {
      return;
    } else {
      this.fetchandPreview();
    }
  },

  components: { VueEasyLightbox, Icon, AdPreview, NoMoreProfile, NavButton },
};
</script>

<style scoped>
/* 1. declare transition */
.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 1s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-leave-active {
  position: absolute;
}

.logo {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 30px;
}

.chatCardGradient {
  background: rgb(0, 0, 0);
  background: radial-gradient(
    circle,
    rgba(0, 0, 0, 1) 0%,
    rgba(84, 77, 63, 1) 50%,
    rgba(0, 0, 0, 1) 100%
  );
}

.lesbian_centerGradient {
  background: rgb(59, 0, 68);
  background: linear-gradient(
    163deg,
    rgb(37 0 42) 0%,
    rgb(87 1 133) 38%,
    rgba(130, 5, 197, 1) 100%
  );
  position: relative;
}

.gay_centerGradient {
  background: rgb(1, 2, 4);
  background: -moz-linear-gradient(
    174deg,
    rgba(1, 2, 4, 1) 0%,
    rgba(0, 107, 177, 1) 46%,
    rgba(0, 155, 255, 1) 100%
  );
  background: -webkit-linear-gradient(
    174deg,
    rgba(1, 2, 4, 1) 0%,
    rgba(0, 107, 177, 1) 46%,
    rgba(0, 155, 255, 1) 100%
  );
  background: linear-gradient(
    174deg,
    rgba(1, 2, 4, 1) 0%,
    rgba(0, 107, 177, 1) 46%,
    rgba(0, 155, 255, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#009bff", GradientType=1);
}

.straight_centerGradient {
  background: rgb(1, 2, 4);
  background: -moz-linear-gradient(
    171deg,
    rgba(1, 2, 4, 1) 0%,
    rgba(97, 87, 64, 1) 46%,
    rgba(131, 112, 69, 1) 100%
  );
  background: -webkit-linear-gradient(
    171deg,
    rgba(1, 2, 4, 1) 0%,
    rgba(97, 87, 64, 1) 46%,
    rgba(131, 112, 69, 1) 100%
  );
  background: linear-gradient(
    171deg,
    rgba(1, 2, 4, 1) 0%,
    rgba(97, 87, 64, 1) 46%,
    rgba(131, 112, 69, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#837045", GradientType=1);
}

.straight_color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(
    180deg,
    rgb(97 69 0) 0%,
    rgba(202, 174, 112, 1) 53%,
    rgb(90 64 0 / 97%) 100%
  ) !important;
}

.lesbian_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(
    180deg,
    rgba(126, 0, 157, 0.9416141456582633) 2%,
    rgba(161, 51, 246, 1) 45%,
    rgba(157, 0, 176, 0.9668242296918768) 96%
  ) !important;
}

.gay_color {
  background: rgb(0, 240, 255);
  background: linear-gradient(
    180deg,
    rgba(0, 240, 255, 1) 0%,
    rgba(0, 156, 255, 1) 100%
  ) !important;
}

.straight_text_color {
  color: #a07a1d;
}

.gay_text_color {
  color: #88c3fa;
}

.lesbian_text_color {
  color: #9e2eec;
}
</style>
